import { DeleteTRoute, DELETE_TROUTE_DIALOG } from "common/dialogs/DeleteTRoute";
import { MobileCollapse } from "common/layouts/SideNavLayout/SideNavContexts";
import { Set } from "immutable";
import React, { Fragment } from "react";

export class TRouteAccordian extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      expanded: Set([]),
    };
  }

  toggleItem = (item) => {
    const { expanded } = this.state;

    this.setState({
      expanded: expanded.has(item) ? Set() : Set([item]),
    });
  };

  render() {
    const { children, deleteTRoute, pinned, pin, unpin } = this.props;
    const { expanded } = this.state;

    return (
      <Fragment>
        {React.Children.map(children, (c) =>
          React.cloneElement(c, {
            expanded,
            toggleItem: this.toggleItem,
            pinned,
            pin,
            unpin,
            deleteTRoute: deleteTRoute,
          })
        )}
      </Fragment>
    );
  }
}

export class TRouteListItemExpandable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      dialog: null,
      newName: null, // sidesteps inline edit name desync, TODO remove once search is in redux
    };
  }

  showDialog = () => this.setState({ dialog: DELETE_TROUTE_DIALOG });
  hideDialog = () => this.setState({ dialog: null });

  deleteConfirmed = () => {
    const { troute, deleteTRoute, executeSearch, onResults } = this.props;

    const deletePromise = deleteTRoute(troute.id).then((res) => res.payload);
    deletePromise.then(() => {
      executeSearch().then((res) => onResults(res));
    });
    return deletePromise;
  };

  // TODO get rid of this once troutes all come from redux
  updateName = (newName) => {
    this.setState({ newName: newName });
  };

  render() {
    const {
      troute,
      expanded,
      expandKey,
      metricUnits,
      condensedComponent: CondensedComponent,
      previewComponent: PreviewComponent,
    } = this.props;
    const { dialog, newName } = this.state;

    return (
      <Fragment>
        <CondensedComponent {...this.props} newName={newName} showDialog={this.showDialog} />
        <MobileCollapse>
          {expanded.has(expandKey) && (
            <PreviewComponent troute={troute} updateName={this.updateName} metricUnits={metricUnits} />
          )}
        </MobileCollapse>
        {dialog === DELETE_TROUTE_DIALOG && (
          <DeleteTRoute troute={troute} onRequestClose={this.hideDialog} onConfirm={this.deleteConfirmed} />
        )}
      </Fragment>
    );
  }
}
